import React, { useState } from 'react';

import { AccordionContainer, AccordionIcon, AccordionContent, AccordionHeader } from './styles';

import { ChevronBackIcon } from '../Icons';
import { Paragraph } from '../Paragraph';

import type { ThemeColor } from '@/styles/theme';

interface AccordionProps {
  title: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
}

export function Accordion({ title, icon, children }: AccordionProps) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const color: ThemeColor = isOpen ? 'primary' : 'bodyTextColor';
  return (
    <AccordionContainer>
      <AccordionHeader onClick={toggleAccordion}>
        <Paragraph weight={600} size="xl" color={color} flexAlignCenter>
          {icon} &nbsp;
          {title}
        </Paragraph>
        <AccordionIcon $opened={isOpen}>
          <ChevronBackIcon />
        </AccordionIcon>
      </AccordionHeader>

      <AccordionContent $opened={isOpen}>{children}</AccordionContent>
    </AccordionContainer>
  );
}
